import React from 'react';
import Botao from './Botao';

/**
 * AcoesEmLote — barra flutuante que aparece quando há itens marcados numa lista.
 * acoes: [{ rotulo, icone, onClick }]. aoLimpar desmarca tudo.
 * Só renderiza com quantidade > 0.
 */
export default function AcoesEmLote({ quantidade, acoes, aoLimpar }) {
  if (!quantidade) return null;

  return (
    <div className="sj-lote" role="region" aria-label="Ações em lote">
      <span className="sj-lote__contagem">{quantidade} selecionado{quantidade > 1 ? 's' : ''}</span>
      <span className="sj-lote__divisor" aria-hidden="true" />
      {acoes.map((a) => (
        <Botao key={a.rotulo} variante="fantasma" tamanho="sm" icone={a.icone} onClick={a.onClick}>
          {a.rotulo}
        </Botao>
      ))}
      <Botao variante="fantasma" icone="close" rotulo="Limpar seleção" onClick={aoLimpar} />
    </div>
  );
}
